var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconClipShare = function SvgIconClipShare(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.242 11.5q.04-1.094.742-1.797.742-.742 1.836-.781h3.36V7.32H7.82q-1.758.04-2.93 1.25-1.17 1.172-1.21 2.93.04 1.758 1.21 2.969 1.172 1.172 2.93 1.21h3.36v-1.6H7.82q-1.093-.04-1.836-.743-.703-.743-.742-1.836m3.438.82h6.64v-1.64H8.68zm7.5-5h-3.36v1.602h3.36q1.094.039 1.797.781.741.704.742 1.797 0 1.094-.742 1.836-.704.703-1.797.742h-3.36v1.602h3.36q1.758-.04 2.93-1.211 1.17-1.21 1.21-2.969-.04-1.758-1.21-2.93-1.172-1.21-2.93-1.25"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconClipShare);
export { ForwardRef as ReactComponent };